import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_MODIFICAR_METEOR, AVIS_INTRODUCCIO_COMPROVAR } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = {};

const esValorBuit = valor => valor === undefined || valor === null || valor === '';

export const obtenirLlistatDeValorsObligatorisDelMeteor = configuracioMeteorSeleccionat => {
    const { camps } = configuracioMeteorSeleccionat;
    return Object.keys(camps).filter( (idCamp)  => {
        return camps[idCamp].obligatori === true;
    });
};

export const revisarValorsOblitorisNoInformats = (dades, valorsObligatoris) => {
    const { valors } = dades;
    let valorsObligatorisNoInformats = {};
    valorsObligatoris.forEach( (idValor) => {
        const valor = valors[idValor];
        if (esValorBuit(valor)) {
            // Si el valor està buit i és obligatori el marquem com erroni
            valorsObligatorisNoInformats[idValor] = true;
        } else {
            valorsObligatorisNoInformats[idValor] = false;
        }
    });
    return valorsObligatorisNoInformats;
};

const valors = (state = ESTAT_INICIAL, action) => {

    switch (action.type) {

        case AVIS_INICIALITZAR:
        case AVIS_INTRODUCCIO_MODIFICAR_METEOR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_COMPROVAR: {
            const { dades, meteors } = action;

            // Es control·lar que hi hagin dades. Si no hi ha es retorna l'estat inicial.
            if (!dades) return ESTAT_INICIAL;

            // Es control·lar que hi hagin el llistat de configuracions de meteors i un meteor seleccionat. Si no hi ha es retorna l'estat inicial.
            const { idMeteorSeleccionat } = dades;
            if (!idMeteorSeleccionat || !meteors) return ESTAT_INICIAL;

            // Es control·lar que el meteor seleccionat tingui una configuració assignada vàlida. Si no hi ha es retorna l'estat inicial.
            const configuracioMeteorSeleccionat = meteors[idMeteorSeleccionat];
            if (!configuracioMeteorSeleccionat) return ESTAT_INICIAL;

            // Array amb el llistat de valors que son obligatoris
            const valorsObligatoris = obtenirLlistatDeValorsObligatorisDelMeteor(configuracioMeteorSeleccionat);

            // Revisar quins valors obligatoris estan informats o no
            return revisarValorsOblitorisNoInformats(dades, valorsObligatoris);
        }

        default:
            return state;
    }
};

export default valors;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/errors/valors.js